import React, {type FC} from 'react';
import {type ProvidedGlobalProps, withGlobalProps} from '../../../../providers/globalPropsProvider';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {
  type IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {Swiper, SwiperSlide} from 'swiper/react';
import {A11y, EffectFade, Keyboard} from 'swiper/modules';
import s from './MainMediaSwiper.scss';
import {useProductGallery} from '../../ProductGalleryProvider/ProductGalleryProvider';

export enum MainMediaSwiperDataHooks {
  Root = 'main-media-swiper-root',
}

export interface MainMediaSwiperProps extends ProvidedGlobalProps, IProvidedTranslationProps {
  media: JSX.Element[];
  swipeToScroll: boolean;
  isMobile: boolean;
  setSwiper: (swiper: any) => void;
}

const MainMediaSwiperComponent: FC<MainMediaSwiperProps> = ({
  media,
  swipeToScroll,
  isMobile,
  setSwiper: propsSetSwiper,
}) => {
  const {changeSelectedIndex} = useProductGallery();
  const {isRTL} = useEnvironment();

  return (
    <div data-hook={MainMediaSwiperDataHooks.Root} className={s.root}>
      <Swiper
        dir={isRTL ? 'rtl' : 'ltr'}
        onSwiper={propsSetSwiper}
        modules={[EffectFade, Keyboard, A11y]}
        effect={'fade'}
        fadeEffect={{crossFade: true}}
        loop={false}
        slidesPerView={1}
        allowTouchMove={swipeToScroll || isMobile}
        keyboard={{enabled: true}}
        threshold={5}
        touchStartPreventDefault={false}
        onSlideChange={(swiperInstance) => changeSelectedIndex(swiperInstance.activeIndex)}
        className={s.swiperContainer}>
        {media.map((child, index) => (
          <SwiperSlide key={index} className={s.swiperSlide}>
            {child}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export const MainMediaSwiper = withGlobalProps(withTranslations('globals.texts')(MainMediaSwiperComponent));
